import React from "react";
import { Link } from "react-router-dom";
import { Table, Space, Button, Popconfirm, message } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { ListComponent, BaseListComponentProps } from "../BaseComponent";
import {
  SearchRequest,
  BreedDeleteRequest,
} from "../../services/api/interfaces/ApiRequest";
import { Pagination } from "components/Pagination";

type BreedListProps = BaseListComponentProps & {
  breeds: any;
  pagination: any;
  loading: boolean;

  history: any;
  searchOptions: any;

  loadBreeds: (args: SearchRequest) => void;
  deleteBreed: (args: BreedDeleteRequest) => Promise<any>;
};

export default class BreedList extends ListComponent<BreedListProps> {
  static defaultProps = {
    loading: false,
  };

  tableColumns = [
    {
      title: "UUID",
      dataIndex: "uuid",
      key: "uuid",
      responsive: ["md"] as any,
      sorter: (a: any, b: any) => a.uuid - b.uuid,
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      defaultSortOrder: "ascend",
      sorter: (a: any, b: any) => a.name - b.name,
    },
    {
      title: "Species",
      dataIndex: ["specie", "name"],
      key: "specie",
      responsive: ["md"] as any,
      // sorter: (a: any, b: any) => a.specie?.name - b.specie?.name
    },
    {
      title: "Actions",
      key: "action",
      align: "right",
      render: (text: string, record: any) => (
        <Space size="middle">
          <Link
            to={`breed/${record.uuid}`}
            ref={(refs) => this.actionRefs.edit.push(refs)}
          >
            <Button type="dashed" shape="round" icon={<EditOutlined />} />
          </Link>

          <div ref={(refs) => this.actionRefs.delete.push(refs)}>
            <Popconfirm
              title="Are you sure about deleting this breed?"
              placement="topLeft"
              onConfirm={() => this.handleDelete(record.uuid)}
            >
              <Button type="dashed" shape="round" icon={<DeleteOutlined />} />
            </Popconfirm>
          </div>
        </Space>
      ),
    },
  ] as any;

  protected load() {
    this.searchOptions = {
      search: {
        ...this.props.searchOptions.search,
      },
      options: {
        ...this.props.searchOptions.options,
      },
    };

    this.props.loadBreeds(this.searchOptions);
  }

  handleDelete = async (uuid: string) => {
    const { deleteBreed } = this.props;

    await deleteBreed({
      breed_uuid: uuid,
    });

    message.success("Breed deleted successfully!");
  };

  render() {
    const { loading, pagination, breeds, loadBreeds } = this.props;

    return (
      <>
        <Table
          loading={loading}
          rowKey="uuid"
          columns={this.tableColumns}
          pagination={false}
          dataSource={breeds}
          onChange={(pagination: any, filters: any, sorter: any) =>
            this.handleTableChange(pagination, sorter, loadBreeds)
          }
        />
        <Pagination
          loading={loading}
          current={pagination?.page}
          pageSize={pagination?.limit}
          length={breeds?.length}
          onChange={(pagination) =>
            this.handleTableChange(pagination, undefined, loadBreeds)
          }
        />
      </>
    );
  }
}
